import PropTypes from 'prop-types';

const StatisticsCopyIcon = ({ className, size = 17 }) => (
	<svg
		className={className}
		width={size}
		height={size}
		viewBox='0 0 16 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'
	>
		<rect x='5.1' y='2.6' width='7.6' height='8.6' rx='1.15' stroke='currentColor' strokeWidth='1.35' opacity='0.48' />
		<rect x='2.3' y='4.8' width='7.6' height='8.6' rx='1.15' stroke='currentColor' strokeWidth='1.4' />
	</svg>
);

StatisticsCopyIcon.propTypes = {
	className: PropTypes.string,
	size: PropTypes.number,
};

export default StatisticsCopyIcon;
